//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { theme } from '~/tailwind.config.js'
import aspectRatio from '~/constants/aspectRatio'

gsap.registerPlugin(ScrollTrigger)

export default {
  props: {
    aspectRatio: {
      type: String,
      default: 'auto',
      validator: value => aspectRatio.includes(value)
    },

    image: {
      type: Object,
      required: true
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    matchHeightToContent: {
      type: Boolean,
      default: false
    },

    minHeight: {
      type: String,
      default: '50vh',
      validator: (value) => {
        return [
          'md', // TODO: remove once old CMS entries with 'md' get updated
          '30vh',
          '50vh',
          '75vh',
          '100vh'
        ].includes(value)
      }
    },

    disableParallax: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      smBreakpoint: theme.extend.screens.sm,
      isSmBreakpointOrAbove: false,
      isMounted: false
    }
  },

  computed: {
    classes () {
      return {
        BaseBanner: true,
        'BaseBanner--full-width': this.fullWidth,
        'BaseBanner--dynamic-height': this.matchHeightToContent,
        [`BaseBanner--min-height-${this.minHeight}`]: this.matchHeightToContent,
        'BaseBanner--first': this.checkIfFirstHero,
        'BaseBanner--no-parallax': this.disableParallax
      }
    },

    mediaQueryList () {
      return window.matchMedia(`(min-width: ${this.smBreakpoint})`)
    },

    getRatio () {
      const ratio = this.aspectRatio.split(':')
      const width = ratio[0]
      const height = ratio[1]

      return `padding-top: ${this.isSmBreakpointOrAbove ? (height / width * 100) : (4 / 3 * 100)}%`
    },

    checkIfFirstHero () {
      if (!this.isMounted) return

      const { hero } = this.$refs
      const heroBanner = hero.offsetParent?.classList.contains('is-first')

      return heroBanner
    }
  },

  mounted () {
    this.isMounted = true

    this.mediaQueryListMatches()
    this.mediaQueryList.addListener(this.mediaQueryListMatches)

    if (!this.disableParallax) this.timeout = setTimeout(() => {
      this.initAnimation()
    }, 200)
  },

  destroyed () {
    this.mediaQueryList.removeListener(this.mediaQueryListMatches)

    if (this.canvasTl) this.canvasTl.kill()
    if (this.timeout) clearTimeout(this.timeout)
  },

  methods: {
    mediaQueryListMatches () {
      this.isSmBreakpointOrAbove = this.mediaQueryList.matches
    },

    initAnimation () {
      this.canvasTl = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: this.$refs.hero,
          start: this.checkIfFirstHero ? 'top top' : 'top bottom',
          end: this.checkIfFirstHero ? 'bottom top' : 'bottom top',
          scrub: 0.1,
          id: 'canvasTl'
          // markers: true
        }
      })
      this.canvasTl
        .fromTo(this.$refs.canvas, {
          y: 0,
          z: 0
        },
        {
          y: this.checkIfFirstHero ? '10%' : '-5%',
          z: 0
        })
    }
  }
}
